import React, { useEffect, useState } from 'react';
import useTranslate from '../../../../../Hooks/useTranslate';
import { FullSizeColumn } from '../../../../../Components/FlexBox';
import { TextField } from '@mui/material';
import Dialog from '../../../../../Components/Dialog';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

const WaveFilterDialog = function WaveFilterDialog({
  open,
  onClose,
  onSubmit,
  edit,
}) {
  const translate = useTranslate();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [storedProcedure, setStoredProcedure] = useState('');
  const [priority, setPriority] = useState(1);

  useEffect(() => {
    if (!edit) return;
    setName(translate(edit.name));
    setDescription(translate(edit.description));
    setStoredProcedure(edit?.storedProcedure);
    setPriority(edit.priority);
  }, [edit]);

  const handleSubmit = () => {
    if (onSubmit && name && description && priority) {
      onSubmit({
        id: edit?.id,
        name: edit?.name ?? name,
        description: edit?.description ?? description,
        storedProcedure,
        uiSchemaConfiguration: edit?.uiSchemaConfiguration,
        priority,
      });
    }
  };

  return (
    <Dialog
      id="wave-filter-dialog"
      title={edit ? 'EDIT_FILTER' : 'NEW_FILTER'}
      icon={<FilterAltOutlinedIcon />}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      width="sm"
      fullWidth
      disableScroll
      dividers
    >
      <FullSizeColumn gap="24px">
        <TextField
          id="name-txtField"
          name="name"
          label={translate('NAME')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          disabled={Boolean(edit)}
        />
        <TextField
          id="description-txtField"
          name="description"
          label={translate('DESCRIPTION')}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          multiline
          minRows={3}
          disabled={Boolean(edit)}
        />
        <TextField
          id="storedProcedure-txtField"
          name="storedProcedure"
          label={translate('STORED_PROCEDURE')}
          value={storedProcedure}
          onChange={(e) => setStoredProcedure(e.target.value)}
        />
        <TextField
          id="priority-txtField"
          name="priority"
          label={translate('PRIORITY_ORDER')}
          type="number"
          value={priority}
          onChange={(e) => setPriority(e.target.value)}
          InputProps={{ inputProps: { min: 1 } }}
          required
        />
      </FullSizeColumn>
    </Dialog>
  );
};

export default WaveFilterDialog;
